import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { routes } from '../routes';
import { HubElement, HubElementContentType } from './useHubElements';

export const useHubElementHandler = () => {
  const history = useHistory();

  return useCallback(
    (element: HubElement) => {
      switch (element.config.contentType) {
        case HubElementContentType.ExternalUrl: {
          if (element.externalUrl) {
            window.open(element.externalUrl, '_blank', 'noopener,noreferrer');
          }
          return;
        }
        case HubElementContentType.Group: {
          // Groups expand inline in the sidebar / profile dropdown / dashboard
          // widget. Click on a Group from any other entry point is a no-op.
          return;
        }
        case HubElementContentType.Flow:
        case HubElementContentType.Lwc: {
          history.push(
            routes.customLightningOut.route.create({
              componentUrl:
                element.flair__Page_Url__c || `default-${element.Id}`,
            }),
          );
          return;
        }
      }
    },
    [history],
  );
};
